import React from 'react';
import { translate } from '../services';

export const SuperCodeDisplay = ( { isReadyAssembled, supercode } ) => { 
  if( isReadyAssembled ){
    return (
    <span className="code-request" >
      <span className="supercode">{ translate( 'Supercode' ) + ':' } </span>
      <span className='code'>{ supercode }</span>
    </span>
    )
  }
  return null;
};
